import React from 'react'
import { Loader2 } from 'lucide-react'

import { useTranslation } from '@/features/locale/LocaleProvider'
import { cn } from '@/lib/utils'
import { Button } from '@/ui/button'
import type { WalletActionPhase } from '@/hooks/useWalletActionButton'

type WalletActionWaitPanelProps = {
  phase: Exclude<WalletActionPhase, 'idle'>
  onCancel?: () => void
  className?: string
  compact?: boolean
}

/** Panel de espera wallet/on-chain con texto descriptivo y cancelación explícita. */
export function WalletActionWaitPanel({
  phase,
  onCancel,
  className,
  compact = false,
}: WalletActionWaitPanelProps) {
  const t = useTranslation()
  const isWallet = phase === 'awaiting-wallet'

  return (
    <div
      className={cn(
        'wallet-action-wait-panel',
        compact && 'wallet-action-wait-panel--compact',
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="wallet-action-wait-panel__spinner size-8 animate-spin text-primary" aria-hidden />
      <p className="wallet-action-wait-panel__title">
        {isWallet ? t.swapUi.awaitingWalletSignature : t.swapUi.awaitingConfirmation}
      </p>
      <p className="wallet-action-wait-panel__hint">
        {isWallet ? t.swapUi.cancelWalletActionHint : t.swapUi.awaitingConfirmationHint}
      </p>
      {isWallet && onCancel ? (
        <Button
          type="button"
          variant="outline"
          className="wallet-action-wait-panel__cancel nm-mobile-simple__cta nm-mobile-simple__cta--secondary h-11 w-full"
          onClick={onCancel}
        >
          {t.swapUi.cancelWalletAction}
        </Button>
      ) : null}
    </div>
  )
}
